<!-- PHASE GROUP -->
<!-- TODO Accessibility: Text alternative for allocation parts? -->
<!-- TODO Allocation wrapper should not be focusable once the modal is open? -->
<!-- TODO Should pressing space key twice close the popup? -->
<!-- TODO Hover effect for allocation wrapper to indicate that mouse is correctly positioned over -->
<!-- TODO Focus effect for allocation wrapper to indicate that the component is focused -->
<!-- TODO Deleting + increasing main phase does not take into account the special functioning, increasing should reduce deleted phases maybe? -->

<!-- TAB NAVIGATION -->
<!-- TODO Active state tabs -->
<!-- TODO Tabs disabled -->
<!-- TODO Moving between tabs should be possible with arrow keys -->

<!-- BUTTONS -->
<!-- TODO Focus-visible state for icons only buttons -->
<!-- TODO Button focus color white as prop? -->

<!-- EDIT POPUP -->
<!-- TODO Does tab order make sense?? -->
<!-- TODO Display backdrop shadow if edit popup is open? -->
<!-- TODO Discard all changes when closing the popup? -->
<!-- TODO Implement change date + change time tabs correctly -->
<!-- TODO The edit popup can move out of the screen without a scrollbar if too many phases are added -->
<!-- TODO Increase height + fix alignment of activity toggle and allocation bar -->

<!-- ALLOCATION -->
<!-- TODO Main phases have some edge cases when inserting cells from one side and deleting from the other one that lead to thrown errors -->

<template>
    <div
        class="inline-flex flex-col"
        :class="[
            allocationHeightClass,
            isPositioned ? 'absolute' : 'relative',
            {
                'z-50': isEditPopupOpen,
            },
        ]"
        :style="allocationPositionStyle"
        :data-allocation-id="props.id"
        @keyup="onKeyUp"
    >
        <Teleport to="body">
            <EditPopup
                v-if="isEditPopupOpen"
                ref="editPopupRef"
                :style="{ ...floatingStyles, ...widthStyle }"
                :left-compensation-in-rem="leftRightCompensationInRem.left"
                :right-compensation-in-rem="leftRightCompensationInRem.right"
            >
                <template v-if="isReviewSectionVisible" #review-section>
                    <ReviewSection
                        :variant="isDeleteConfirmationVisible ? 'Error' : 'Neutral'"
                        :flash-count="snapshot.context.refusedDismissCount"
                    >
                        <div class="flex flex-col gap-1">
                            <template v-if="isDeleteConfirmationVisible">
                                <div class="flex flex-row gap-1 justify-between">
                                    <Button
                                        size="Extra-Small"
                                        variant="Neutral-Light"
                                        @click="send({ type: 'Abort deleting allocation' })"
                                    >
                                        <template #icon>
                                            <UndoIcon class="size-4" />
                                        </template>
                                        {{ $t('keep-allocation') }}
                                    </Button>

                                    <Button
                                        v-if="
                                            snapshot.matches({
                                                'Edit popup open': {
                                                    'Delete area': {
                                                        'Delete area open': 'Default',
                                                    },
                                                },
                                            })
                                        "
                                        size="Extra-Small"
                                        variant="Danger-Light"
                                        @click="send({ type: 'Confirm deleting allocation' })"
                                    >
                                        <template #icon>
                                            <DeleteForeverIcon class="size-4" />
                                        </template>
                                        {{ $t('delete-allocation-permanently') }}
                                    </Button>

                                    <Button
                                        v-if="
                                            snapshot.matches({
                                                'Edit popup open': {
                                                    'Delete area': {
                                                        'Delete area open': 'Deleting allocation pending',
                                                    },
                                                },
                                            })
                                        "
                                        size="Extra-Small"
                                        variant="Danger-Light"
                                        :disabled-explanation="$t('deleting-allocation-pending')"
                                    >
                                        <template #icon>
                                            <AllDoneIcon class="size-4" />
                                        </template>
                                        {{ $t('deleting-allocation-pending-label') }}
                                    </Button>

                                    <Button
                                        v-if="
                                            snapshot.matches({
                                                'Edit popup open': {
                                                    'Delete area': {
                                                        'Delete area open': 'Retry deleting allocation',
                                                    },
                                                },
                                            })
                                        "
                                        size="Extra-Small"
                                        variant="Danger-Light"
                                        @click="send({ type: 'Confirm changes' })"
                                    >
                                        <template #icon>
                                            <RefreshIcon class="size-4" />
                                        </template>
                                        {{ $t('deleting-allocation-retry') }}
                                    </Button>
                                </div>
                            </template>

                            <template v-if="isChangeConfirmationVisible">
                                <div class="flex flex-row gap-1 justify-between">
                                    <Button
                                        size="Extra-Small"
                                        variant="Neutral-Light"
                                        @click="send({ type: 'Discard changes' })"
                                    >
                                        <template #icon>
                                            <UndoIcon class="size-4" />
                                        </template>
                                        {{ $t('discard-changes') }}
                                    </Button>

                                    <Button
                                        v-if="
                                            snapshot.matches({
                                                'Edit popup open': {
                                                    'Review area': {
                                                        'Review area open': 'Default',
                                                    },
                                                },
                                            })
                                        "
                                        size="Extra-Small"
                                        variant="Info-Light"
                                        :disabled-explanation="isMainPhaseMissingMessage"
                                        @click="send({ type: 'Confirm changes' })"
                                    >
                                        <template #icon>
                                            <AllDoneIcon class="size-4" />
                                        </template>
                                        {{ $t('change-phases-permanently') }}
                                    </Button>

                                    <Button
                                        v-if="
                                            snapshot.matches({
                                                'Edit popup open': {
                                                    'Review area': {
                                                        'Review area open': 'Changes pending',
                                                    },
                                                },
                                            })
                                        "
                                        size="Extra-Small"
                                        variant="Info-Light"
                                        :disabled-explanation="$t('phase-update-pending')"
                                    >
                                        <template #icon>
                                            <AllDoneIcon class="size-4" />
                                        </template>
                                        {{ $t('phase-update-pending-label') }}
                                    </Button>

                                    <Button
                                        v-if="
                                            snapshot.matches({
                                                'Edit popup open': {
                                                    'Review area': {
                                                        'Review area open': 'Retry changes update',
                                                    },
                                                },
                                            })
                                        "
                                        size="Extra-Small"
                                        variant="Danger-Light"
                                        @click="send({ type: 'Confirm changes' })"
                                    >
                                        <template #icon>
                                            <RefreshIcon class="size-4" />
                                        </template>
                                        {{ $t('phase-update-retry') }}
                                    </Button>
                                </div>
                            </template>
                        </div>
                    </ReviewSection>
                </template>

                <template #navigation-section>
                    <div class="flex flex-row w-full" :style="widthStyle">
                        <div class="order-2 flex flex-row gap-0 items-center mx-1 grow justify-center">
                            <Tooltip v-if="isReferenceAllocation">
                                <template #trigger="tooltipProps">
                                    <div class="relative">
                                        <TourIcon
                                            class="size-6 text-gray-100 focus-visible:outline-offset-2 focus-visible:outline-2 focus-visible:outline-gray-50 p-1 rounded-sm hover:bg-gray-700 hover:underline text-xl font-bold"
                                            v-bind="tooltipProps"
                                            tabindex="0"
                                        />

                                        <div
                                            v-if="hasReferenceAllocationChangeMarker"
                                            class="size-1.5 absolute bg-red-700 rounded-full shadow-[0_0_0.0625rem_0.0625rem] shadow-red-50/50 top-0.5 right-0.5"
                                        />
                                    </div>
                                </template>

                                <template #text>
                                    {{ $t('is-reference-allocation-icon-text') }}
                                </template>
                            </Tooltip>

                            <RouterLink
                                :to="props.linkTarget"
                                class="focus-visible:outline-offset-2 focus-visible:outline-2 focus-visible:outline-gray-50 px-1 rounded-sm hover:bg-gray-700 hover:underline text-xl font-bold text-gray-100 w-max"
                                target="_blank"
                            >
                                {{ props.groupLabel }}
                            </RouterLink>
                            <span class="text-gray-200 px-0.5">-</span>
                            <RouterLink
                                :to="props.allocationVariant.target"
                                class="focus-visible:outline-offset-2 focus-visible:outline-2 focus-visible:outline-gray-50 px-1 rounded-sm hover:bg-gray-700 hover:underline font-light text-gray-200 w-max"
                                target="_blank"
                                @mouseover="isAllocationVariantHovered = true"
                                @mouseleave="isAllocationVariantHovered = false"
                            >
                                <AllocationVariantIndex
                                    :index="props.allocationVariant.index"
                                    text-size="Inherit"
                                    class="inline"
                                    :light-color-override="
                                        isAllocationVariantHovered ? 'text-gray-200' : 'text-gray-300'
                                    "
                                    :dark-color-override="
                                        isAllocationVariantHovered ? 'text-gray-200' : 'text-gray-400'
                                    "
                                />
                                <span v-if="props.allocationVariant.label">
                                    ({{ props.allocationVariant.label }})
                                </span>
                            </RouterLink>
                        </div>

                        <div class="order-3 flex flex-row gap-1.5 items-center px-1.5">
                            <Button
                                size="Extra-Small"
                                variant="Danger-Strong"
                                :icon-description="$t('delete-allocation')"
                                @click="
                                    triggerHideTooltip();
                                    send({ type: 'Delete allocation' });
                                "
                            >
                                <template #icon>
                                    <DeleteForeverIcon class="size-4" />
                                </template>
                            </Button>

                            <div class="bg-gray-500 w-px h-6" />

                            <Button
                                class="text-gray-200"
                                size="Extra-Small"
                                variant="Transparent"
                                :icon-description="$t('close-allocation-edit-popup')"
                                @click="
                                    triggerHideTooltip();
                                    send({ type: 'Close popup' });
                                "
                            >
                                <template #icon>
                                    <CloseIcon class="size-4" />
                                </template>
                            </Button>
                        </div>

                        <div class="order-1 self-end">
                            <div class="flex flex-row gap-1 mx-2.5">
                                <AllocationEditTabNavigationItem
                                    icon="Striped-Solid-Bars"
                                    :status="isEditEntireAllocationTabActive ? 'Active' : 'Default'"
                                    :has-changes="hasEditEntireAllocationTabChanges"
                                    @change-tab="
                                        triggerHideTooltip();
                                        send({ type: 'Click edit entire allocation' });
                                    "
                                />

                                <AllocationEditTabNavigationItem
                                    icon="Edit-Phases"
                                    :status="isEditPhasesTabActive ? 'Active' : 'Default'"
                                    :has-changes="hasEditPhasesTabChanges"
                                    @change-tab="
                                        triggerHideTooltip();
                                        send({ type: 'Click tab edit phases' });
                                    "
                                />

                                <AllocationEditTabNavigationItem
                                    icon="Move-Date"
                                    :status="isMoveDateTabActive ? 'Active' : 'Default'"
                                    :has-changes="hasMoveDateTabChanges"
                                    @change-tab="
                                        triggerHideTooltip();
                                        send({ type: 'Click tab move date' });
                                    "
                                />
                            </div>
                        </div>
                    </div>
                </template>

                <template #content-section>
                    <div
                        v-if="isEditEntireAllocationTabActive"
                        class="w-full flex flex-row justify-between items-start py-0.5 gap-4"
                    >
                        <ActivatedToggle
                            :is-active="snapshot.context.isAllocationOptional.temporary"
                            size="Extra-Small"
                            @toggle="send({ type: 'Toggle allocation optional' })"
                        >
                            {{ $t('allocation-optional') }}
                        </ActivatedToggle>

                        <div class="flex flex-row flex-wrap gap-0.5 items-center">
                            <Button
                                size="Extra-Small"
                                variant="Neutral-Strong"
                                :icon-description="
                                    isReferenceAllocation
                                        ? $t('demote-to-normal-allocation-full')
                                        : $t('promote-to-reference-allocation-full')
                                "
                                @click="
                                    triggerHideTooltip();
                                    isReferenceAllocation
                                        ? send({ type: 'Demote to normal allocation' })
                                        : send({
                                              type: 'Promote to reference allocation',
                                              newReferenceAllocationId: props.id,
                                          });
                                "
                            >
                                <template #icon>
                                    <TourIcon class="size-4" />
                                </template>

                                <template v-if="isReferenceAllocation">
                                    {{ $t('demote-to-normal-allocation-abbreviated') }}
                                </template>
                                <template v-else>
                                    {{ $t('promote-to-reference-allocation-abbreviated') }}
                                </template>
                            </Button>

                            <Button
                                size="Extra-Small"
                                variant="Neutral-Light"
                                :icon-description="$t('jump-to-referenced-allocation')"
                                :disabled-explanation="
                                    isReferenceAllocation
                                        ? $t('jump-to-referenced-allocation-disabled')
                                        : !snapshot.context.isReferenceAllocationRegistered
                                          ? $t('jump-to-referenced-allocation-not-visible')
                                          : undefined
                                "
                                @click="onJumpToReferenceAllocation"
                            >
                                <template #icon>
                                    <JumpIcon class="size-4" />
                                </template>
                            </Button>
                        </div>
                    </div>

                    <template v-if="isMoveDateTabActive">TODO</template>
                </template>

                <template #allocation-preview-section>
                    <AllocationWrapper
                        v-if="isEditEntireAllocationTabActive"
                        status="Focused"
                        :is-clickable="false"
                        form="Start-End"
                    >
                        <template v-if="props.label || $slots['tooltip-header']" #tooltip-header>
                            <slot name="tooltip-header">
                                <div class="w-full text-center text-gray-700">
                                    {{ props.label }}
                                </div>
                            </slot>
                        </template>

                        <template #tooltip-text>
                            <slot name="tooltip-text">
                                <div class="w-full text-center text-gray-500">
                                    {{ clickBehavior.tooltipText }}
                                </div>
                            </slot>
                        </template>

                        <template v-for="(phaseGroup, phaseGroupIndex) in snapshot.context.phaseGroups">
                            <!-- Inserted before allocation parts -->
                            <template v-if="phaseGroup.temporaryCellSpanBefore > 0">
                                <AllocationPart
                                    v-for="allocationPartIndex in phaseGroup.temporaryCellSpanBefore"
                                    :key="`${phaseGroup.id}-before-${allocationPartIndex}`"
                                    :color="phaseGroup.color"
                                    :form="phaseGroupIndex === 0 && allocationPartIndex === 1 ? 'Start' : 'Middle'"
                                    :is-phase-end="false"
                                    :variant="
                                        snapshot.context.isAllocationOptional.temporary
                                            ? 'Light-Optional'
                                            : 'Light-Mandatory'
                                    "
                                    :specialization="null"
                                    :has-temporary-change-marker="false"
                                />
                            </template>

                            <!-- Confirmed allocation parts -->
                            <AllocationPart
                                v-for="allocationPartIndex in phaseGroup.confirmedCellSpan"
                                :key="`${phaseGroup.id}-${allocationPartIndex}`"
                                :color="phaseGroup.color"
                                :form="
                                    mapPhaseFormsToAllocationParts(
                                        phaseGroup.confirmedCellSpan,
                                        calculateConfirmedPhaseForm(
                                            timelineRange.startDateTime.value,
                                            timelineRange.endDateTime.value,
                                            props.startDateTime,
                                            props.endDateTime,
                                            phaseGroup.startDateTime,
                                            phaseGroup.endDateTime,
                                            hasTemporaryPhasesBefore(
                                                phaseGroup.temporaryCellSpanBefore,
                                                snapshot.context.phaseGroups,
                                                phaseGroupIndex,
                                            ),
                                            hasTemporaryPhasesAfter(
                                                phaseGroup.temporaryCellSpanAfter,
                                                snapshot.context.phaseGroups,
                                                phaseGroupIndex,
                                            ),
                                            true,
                                        ),
                                        phaseGroup.temporaryCellSpanBefore > 0,
                                        phaseGroup.temporaryCellSpanAfter > 0,
                                    )[allocationPartIndex - 1]
                                "
                                :is-phase-end="isPhaseEnd(allocationPartIndex, phaseGroup)"
                                :variant="
                                    calculateVariant(
                                        snapshot.context.isAllocationOptional.temporary,
                                        phaseGroup.confirmedVisibleCellSpan,
                                        phaseGroup.temporaryCellSpanBefore,
                                        phaseGroup.temporaryCellSpanAfter,
                                        allocationPartIndex,
                                    )
                                "
                                :specialization="phaseGroup.temporarySpecialization ?? null"
                                :has-temporary-change-marker="
                                    phaseGroup.temporarySpecialization !== phaseGroup.confirmedSpecialization
                                "
                            />

                            <!-- Inserted after allocation parts -->
                            <template v-if="phaseGroup.temporaryCellSpanAfter > 0">
                                <AllocationPart
                                    v-for="allocationPartIndex in phaseGroup.temporaryCellSpanAfter"
                                    :key="`${phaseGroup.id}-after-${allocationPartIndex}`"
                                    :color="phaseGroup.color"
                                    :form="
                                        phaseGroupIndex === snapshot.context.phaseGroups.length - 1 &&
                                        allocationPartIndex === phaseGroup.temporaryCellSpanAfter
                                            ? 'End'
                                            : 'Middle'
                                    "
                                    :is-phase-end="allocationPartIndex === phaseGroup.temporaryCellSpanAfter"
                                    :variant="
                                        snapshot.context.isAllocationOptional.temporary
                                            ? 'Light-Optional'
                                            : 'Light-Mandatory'
                                    "
                                    :specialization="null"
                                    :has-temporary-change-marker="false"
                                />
                            </template>
                        </template>
                    </AllocationWrapper>

                    <div
                        v-if="isEditPhasesTabActive"
                        class="bg-gray-50 before:rounded-full wrapper-border-gray-700 rounded-full flex flex-row gap-px"
                    >
                        <PhaseGroup
                            v-for="(phaseGroup, phaseGroupIndex) in snapshot.context.phaseGroups"
                            :key="phaseGroup.id"
                            :cell-span-before="phaseGroup.temporaryCellSpanBefore"
                            :confirmed-cell-span="phaseGroup.confirmedCellSpan"
                            :cell-span-after="phaseGroup.temporaryCellSpanAfter"
                            :is-left-end-position="phaseGroup.isLeftEndPosition"
                            :is-right-end-position="phaseGroup.isRightEndPosition"
                            :position="phaseGroup.position"
                            :insert-phase-before="phaseGroup.insertPhaseBefore"
                            :insert-phase-after="phaseGroup.insertPhaseAfter"
                            :color="phaseGroup.color"
                            :type="phaseGroup.usage.type"
                            :phase-name="getPhaseName(phaseGroup.usage.type)"
                            :allowed-specializations="
                                getAllowedSpecializationTypesForPhaseType(phaseGroup.usage.type, props.isInside)
                            "
                            :selected-specialization="phaseGroup.temporarySpecialization ?? null"
                            :has-temporary-change-marker="
                                phaseGroup.temporarySpecialization !== phaseGroup.confirmedSpecialization
                            "
                            :is-change-type-popup-open="phaseGroup.isChangeTypePopupOpen"
                            :is-allocation-optional="snapshot.context.isAllocationOptional.temporary"
                            :form="
                                calculateConfirmedPhaseForm(
                                    timelineRange.startDateTime.value,
                                    timelineRange.endDateTime.value,
                                    props.startDateTime,
                                    props.endDateTime,
                                    phaseGroup.startDateTime,
                                    phaseGroup.endDateTime,
                                    hasTemporaryPhasesBefore(
                                        phaseGroup.temporaryCellSpanBefore,
                                        snapshot.context.phaseGroups,
                                        phaseGroupIndex,
                                    ),
                                    hasTemporaryPhasesAfter(
                                        phaseGroup.temporaryCellSpanAfter,
                                        snapshot.context.phaseGroups,
                                        phaseGroupIndex,
                                    ),
                                    true,
                                )
                            "
                            :has-temporary-phases-before="phaseGroup.temporaryCellSpanBefore > 0"
                            :has-temporary-phases-after="phaseGroup.temporaryCellSpanAfter > 0"
                            @insert-phase-before="
                                (send({
                                    type: 'Insert phase',
                                    position: 'Before',
                                    insertingPosition: phaseGroup.usage.position,
                                }),
                                triggerHideTooltip())
                            "
                            @insert-phase-after="
                                (send({
                                    type: 'Insert phase',
                                    position: 'After',
                                    insertingPosition: phaseGroup.usage.position,
                                }),
                                triggerHideTooltip())
                            "
                            @increase-phase-length-before="
                                send({
                                    type: 'Increase phase length',
                                    position: 'Before',
                                    phaseGroupType: phaseGroup.usage.type,
                                })
                            "
                            @decrease-phase-length-before="
                                send({
                                    type: 'Decrease phase length',
                                    position: 'Before',
                                    phaseGroupType: phaseGroup.usage.type,
                                })
                            "
                            @increase-phase-length-after="
                                send({
                                    type: 'Increase phase length',
                                    position: 'After',
                                    phaseGroupType: phaseGroup.usage.type,
                                })
                            "
                            @decrease-phase-length-after="
                                send({
                                    type: 'Decrease phase length',
                                    position: 'After',
                                    phaseGroupType: phaseGroup.usage.type,
                                })
                            "
                            @show-change-type-popup="
                                send({
                                    type: 'Show change type popup',
                                    phaseGroupType: phaseGroup.usage.type,
                                })
                            "
                            @hide-change-type-popup="
                                send({
                                    type: 'Hide change type popup',
                                })
                            "
                            @change-specialization="
                                (specialization) =>
                                    send({
                                        type: 'Change specialization type',
                                        specialization,
                                        phaseGroupId: phaseGroup.id,
                                    })
                            "
                        />
                    </div>
                </template>
            </EditPopup>
        </Teleport>

        <!-- Allocation -->
        <div class="flex">
            <AllocationWrapper
                ref="allocationWrapperRef"
                class="relative rounded-full"
                :class="{
                    'fading-out-highlight': isHighlighted,
                }"
                :status="allocationWrapperStatus"
                :is-clickable="clickBehavior.isClickable"
                :allocation-label="props.label"
                :style="allocationWrapperWidthStyle"
                :form="snapshot.context.allocationForm"
                @mousedown="onMouseDown"
                @mouseup="onTrigger"
                @mouseenter="isAllocationWrapperHovered = true"
                @mouseleave="isAllocationWrapperHovered = false"
                @focus="send({ type: 'Activate popup' })"
                @blur="send({ type: 'Blur' })"
                @keypress.space="onTrigger"
            >
                <template v-if="props.label || $slots['tooltip-header']" #tooltip-header>
                    <slot name="tooltip-header">
                        <div class="w-full text-center" :class="{ 'text-gray-700': !clickBehavior.isClickable }">
                            {{ props.label }}
                        </div>
                    </slot>
                </template>

                <template #tooltip-text>
                    <slot name="tooltip-text">
                        <div class="w-full text-center" :class="{ 'text-gray-500': !clickBehavior.isClickable }">
                            {{ clickBehavior.tooltipText }}
                        </div>
                    </slot>
                </template>

                <template v-for="(phaseGroup, phaseGroupIndex) in snapshot.context.phaseGroups">
                    <template v-if="phaseGroup.confirmedVisibleCellSpan > 0">
                        <AllocationPart
                            v-for="cellIndex in phaseGroup.confirmedVisibleCellSpan"
                            :key="`${phaseGroup.id}-${cellIndex}`"
                            :debug="cellIndex"
                            :color="phaseGroup.color"
                            :form="
                                mapPhaseFormsToAllocationParts(
                                    phaseGroup.confirmedVisibleCellSpan,
                                    calculateConfirmedPhaseForm(
                                        timelineRange.startDateTime.value,
                                        timelineRange.endDateTime.value,
                                        snapshot.context.phaseGroups[0].startDateTime,
                                        snapshot.context.phaseGroups.at(-1)!.endDateTime,
                                        phaseGroup.startDateTime,
                                        phaseGroup.endDateTime,
                                        hasTemporaryPhasesBefore(
                                            phaseGroup.temporaryCellSpanBefore,
                                            snapshot.context.phaseGroups,
                                            phaseGroupIndex,
                                        ),
                                        phaseGroup.temporaryCellSpanAfter > 0,
                                        false,
                                    ),
                                    phaseGroup.temporaryCellSpanBefore > 0,
                                    phaseGroup.temporaryCellSpanAfter > 0,
                                )[cellIndex - 1]
                            "
                            :is-phase-end="isPhaseEnd(cellIndex, phaseGroup)"
                            :variant="mapVariant(props.variant, props.isOptional)"
                            :specialization="phaseGroup.temporarySpecialization ?? null"
                            :has-temporary-change-marker="
                                phaseGroup.temporarySpecialization !== phaseGroup.confirmedSpecialization
                            "
                        />
                    </template>
                </template>

                <TourIcon
                    v-if="isReferenceAllocation"
                    class="absolute top-0 left-0.75 size-4 fill-gray-950 stroke-white stroke-[1.5] [paint-order:stroke]"
                />

                <svg
                    class="text-xs absolute top-0 w-full"
                    :class="[
                        allocationHeightClass,
                        isReferenceAllocation ? 'left-4.5' : 'left-0',
                        props.labelStyle === 'Muted' ? 'font-normal' : 'font-semibold',
                    ]"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <defs>
                        <clipPath :id="clipPathId">
                            <rect x="0" y="0" :width="`${textClipWidthInPx}px`" height="100%" />
                        </clipPath>
                    </defs>
                    <text
                        :x="labelPaddingInRem * 16"
                        y="50%"
                        dy="0.75"
                        dominant-baseline="middle"
                        text-anchor="start"
                        class="stroke-white stroke-[1.5] [paint-order:stroke]"
                        :class="props.labelStyle === 'Muted' ? 'fill-gray-500' : 'fill-gray-950'"
                        :clip-path="`url(#${clipPathId})`"
                    >
                        {{ props.label }}
                    </text>
                </svg>
            </AllocationWrapper>
        </div>
    </div>
</template>

<script setup lang="ts">
import { UpdateAllocationReturn } from '@/allocation/composables/useUpdateAllocations';
import ActivatedToggle from '@/components/ActivatedToggle/ActivatedToggle.vue';
import JumpIcon from '@/components/Icon/JumpIcon.vue';
import TourIcon from '@/components/Icon/TourIcon.vue';
import { AllocationUsageType, ProjectAllocationUsageType } from '@/generated/graphql';
import { autoUpdate, offset, useFloating } from '@floating-ui/vue';
import { onKeyStroke, useElementSize } from '@vueuse/core';
import { useMachine } from '@xstate/vue';
import { useFluent } from 'fluent-vue';
import { computed, inject, nextTick, onUnmounted, provide, ref, watch, watchEffect } from 'vue';
import { RouterLink, useRouter } from 'vue-router';
import AllocationVariantIndex from '../../AllocationVariantIndex/AllocationVariantIndex.vue';
import Button from '../../Button/Button.vue';
import AllDoneIcon from '../../Icon/AllDoneIcon.vue';
import CloseIcon from '../../Icon/CloseIcon.vue';
import DeleteForeverIcon from '../../Icon/DeleteForeverIcon.vue';
import RefreshIcon from '../../Icon/RefreshIcon.vue';
import UndoIcon from '../../Icon/UndoIcon.vue';
import Tooltip from '../../Tooltip/Tooltip.vue';
import { triggerHideTooltipKey } from '../../Tooltip/injectionKeys';
import { useLocationSelectionStore } from '../LocationSelection.store';
import { useTimelineStore } from '../Timeline.store';
import { Allocation, AllocationPhaseUpdate, PhaseTypeDatabase } from '../Timeline.types';
import { calculateConfirmedPhaseForm, mapPhaseFormsToAllocationParts } from '../allocation/allocationForm';
import AllocationEditTabNavigationItem from '../edit-popup/AllocationEditTabNavigationItem.vue';
import EditPopup from '../edit-popup/EditPopup.vue';
import ReviewSection from '../edit-popup/ReviewSection.vue';
import {
    emitDeleteAllocationKey,
    emitUpdateAllocationKey,
    positionInLayoutRowKey,
    registerAllocationKey,
    timelineRangeKey,
    unregisterAllocationKey,
} from '../injectionKeys';
import PhaseGroup from '../phase-group/PhaseGroup.vue';
import { allocationHeightClass, columnWidthInRem } from '../sharedStyles';
import { createStateMachine, isMainPhasePresent, PhaseGroup as PhaseGroupType } from './Allocation.state';
import AllocationPart from './AllocationPart.vue';
import AllocationWrapper from './AllocationWrapper.vue';
import { SpecializationType } from './SpecializationMappings';
import { AllocationUsage } from './types';

const router = useRouter();
const { $t } = useFluent();

export type AllocationProps = Allocation & {
    allocationUsages: AllocationUsage[];
    phaseTypePriorities?: number[];
};

const props = withDefaults(defineProps<AllocationProps>(), { labelStyle: 'Strong' });

defineEmits<{
    (e: 'close-allocation'): void;
}>();

const timelineRange = inject(timelineRangeKey);
if (!timelineRange) {
    throw new Error('Allocation must be used within a Timeline component');
}

const getPositionInLayoutRow = inject(positionInLayoutRowKey);

const position = computed(() => getPositionInLayoutRow?.(props.id));

const allocationPositionStyle = computed(() => {
    const pos = position.value;
    if (!pos || pos.left === null || pos.top === null) {
        return {};
    }

    return {
        left: `${pos.left}rem`,
        top: `${pos.top}rem`,
        pointerEvents: 'auto',
    } as const;
});

const isPositioned = computed(() => {
    const pos = position.value;
    return pos !== undefined && pos.left !== null && pos.top !== null;
});

function scrollAllocationIntoViewportCenter() {
    allocationWrapperRef.value?.wrapperRef.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
    });
}

const isHighlighted = ref(false);
let highlightTimeout: ReturnType<typeof setTimeout> | null = null;

function triggerHighlight() {
    // Clear any existing timeout to restart the animation
    if (highlightTimeout) {
        clearTimeout(highlightTimeout);
    }

    // Force restart the CSS animation by toggling the highlight state
    isHighlighted.value = false;

    // Use nextTick() to ensure the DOM updates before restarting the animation
    nextTick(() => {
        scrollAllocationIntoViewportCenter();

        isHighlighted.value = true;

        // Reset after animation completes (5s based on the CSS animation)
        highlightTimeout = setTimeout(() => {
            isHighlighted.value = false;
            highlightTimeout = null;
        }, 5000);
    });
}

// Allocations can register themselves to be highlighted independently of how/where they are rendered in the timeline
const registerAllocation = inject(registerAllocationKey);
const unregisterAllocation = inject(unregisterAllocationKey);

if (registerAllocation) {
    registerAllocation(props.id, triggerHighlight);
}

onUnmounted(() => {
    if (unregisterAllocation) {
        unregisterAllocation(props.id);
    }
});

function onKeyUp(event: KeyboardEvent) {
    switch (event.key) {
        case 'Delete':
            send({ type: 'Delete allocation' });
            break;
    }
}

const updateAllocation = inject(emitUpdateAllocationKey);

const deleteAllocation = inject(emitDeleteAllocationKey);

async function onDeleteAllocation(): Promise<void> {
    if (!deleteAllocation) {
        throw new Error('Missing injected deleteAllocation function');
    }

    return new Promise<void>((resolve, reject) => {
        deleteAllocation(props.id, props.locationTypeCategory, (isSuccess: boolean) => {
            if (isSuccess) {
                resolve();
            } else {
                reject(new Error('Delete allocation failed'));
            }
        });
    });
}

const store = useTimelineStore();
const locationSelectionStore = useLocationSelectionStore();

async function onUpdateAllocation(
    phases: AllocationPhaseUpdate[],
    isAllocationOptional: boolean,
    referenceAllocationId: string | null,
): Promise<UpdateAllocationReturn> {
    if (!updateAllocation) {
        throw new Error('Missing injected updatePhases function');
    }

    // use nextTick here to ensure, that props used in updateAllocation
    // are updated properly
    await nextTick();

    return await updateAllocation(
        phases,
        props.startDateTime,
        props.endDateTime,
        copyTargets.value,
        props.id,
        props.locationTypeCategory,
        props.allocationVariant.id,
        props.isOptional,
        isAllocationOptional,
        store.getReferenceAllocationId(props.allocationVariant.id),
        referenceAllocationId,
    );
}

// The store owns the variant's reference allocation id; this prop only seeds it, and only for the first
// allocation of the variant to mount. `allocationVariant.referenceAllocationId` is baked in when the variant
// is mapped and never refreshed afterwards, so it goes stale as soon as the reference is changed here.
store.registerVariantReferenceAllocationId(props.allocationVariant.id, props.allocationVariant.referenceAllocationId);
onUnmounted(() => {
    store.unregisterVariantReferenceAllocationId(props.allocationVariant.id);
});

// Read back from the store rather than using the prop directly: on a remount (switching view modes) the
// stale prop would otherwise resurrect the previous reference allocation in this machine, leaving the old
// allocation still marked as the reference while the store and the row already agree on the new one.
const initialReferenceAllocationId = store.getReferenceAllocationId(props.allocationVariant.id);

function showLocationCheckboxes() {
    locationSelectionStore.activateSelection(props.locationId);
}

function hideLocationCheckboxes() {
    locationSelectionStore.deactivateSelection();
}

function discardLocationCheckboxChanges() {
    locationSelectionStore.discardSelectionChanges();
}

// Selection mode is intentionally NOT deactivated when an allocation unmounts. Collapsing/expanding
// sections (or hierarchy branches) unmounts day-row allocations, and that must never cancel an
// active selection — including the section that holds the origin allocation. Selection ends via
// explicit user action (popup confirm/cancel), when the whole timeline unmounts (see Timeline), or
// when the source's own first-column row is unregistered (see LocationSelection.store) — which
// happens on a display-mode switch but not on a collapse, since those rows stay mounted.

const stateMachine = createStateMachine(
    props.phases,
    props.isOptional,
    () => clickBehavior.value.isClickable,
    onDeleteAllocation,
    onUpdateAllocation,
    (referenceAllocationId) => {
        store.setReferenceAllocationId(props.allocationVariant.id, referenceAllocationId);
    },
    props.startDateTime,
    timelineRange.startDateTime.value,
    timelineRange.endDateTime.value,
    (isOpen: boolean) => {
        if (isOpen) {
            showLocationCheckboxes();
        } else {
            hideLocationCheckboxes();
        }
    },
    discardLocationCheckboxChanges,
    hideLocationCheckboxes,
    props.id,
    initialReferenceAllocationId,
    (allocationId: string) => store.isAllocationRegistered(allocationId),
    props.allocationUsages,
    props.phaseTypePriorities,
);

const { snapshot, send } = useMachine(stateMachine);

watch(
    () => store.getReferenceAllocationId(props.allocationVariant.id),
    (newReferenceAllocationId) => {
        if (!store.referenceAllocationIdByVariantId.has(props.allocationVariant.id)) {
            return;
        }
        send({ type: 'Update reference allocation id', newReferenceAllocationId });
    },
);

watch(
    () => props.phases,
    (newPhases) => {
        send({ type: 'Update phases', phases: newPhases, allocationStartDateTime: props.startDateTime });
    },
    { deep: true },
);

const isReferenceAllocation = computed(() => snapshot.value.context.referenceAllocation.temporaryId === props.id);

const isMainPhaseMissingMessage = computed(() =>
    isMainPhasePresent(snapshot.value.context.phaseGroups) ? undefined : $t('main-phase-required'),
);
const hasReferenceAllocationChangeMarker = computed(() => {
    return (
        snapshot.value.context.referenceAllocation.temporaryId !==
        snapshot.value.context.referenceAllocation.confirmedId
    );
});

// Watch for changes in reference allocation registration and update the state machine
watch(
    () => {
        const referenceAllocationId = snapshot.value.context.referenceAllocation.temporaryId;
        return referenceAllocationId ? store.isAllocationRegistered(referenceAllocationId) : false;
    },
    (isReferenceAllocationRegistered) => {
        send({ type: 'Update reference allocation registration', isReferenceAllocationRegistered });
    },
);

const copyTargets = computed(() => {
    // Only the allocation whose edit popup is open needs the live selection (to drive the copy count).
    // Gating on the open state keeps closed allocations' watchers independent of the selection store.
    if (!snapshot.value.matches('Edit popup open')) {
        return [];
    }
    // Each target carries its type: the duplicate mutation needs to route it to a room or an area, and the
    // ticked row is the only place that knows which.
    return locationSelectionStore.copyTargets;
});

watch(
    () => copyTargets.value.length,
    (newLength, oldLength) => {
        if (newLength !== oldLength) {
            send({ type: 'Location selection changed', countOtherLocations: newLength });
        }
    },
);

watchEffect(() => {
    send({
        type: 'Change start and or end',
        startDateTime: timelineRange.startDateTime.value,
        endDateTime: timelineRange.endDateTime.value,
    });
});

const isEditPopupOpen = computed(() => snapshot.value.matches('Edit popup open'));

/**
 * The popup is teleported to <body>, so keys pressed inside it never bubble through this component's own
 * subtree — `document` is the nearest ancestor of both the allocation bar and the popup. Listening in the
 * bubble phase lets a nested overlay consume Escape first (see ChangeTypePopupContent). Scoping the target
 * to the open state keeps this to one listener in total instead of one per mounted allocation.
 */
onKeyStroke('Escape', () => send({ type: 'Press escape' }), {
    target: computed(() => (isEditPopupOpen.value ? document : null)),
});

const isDeleteConfirmationVisible = computed(() =>
    snapshot.value.matches({ 'Edit popup open': { 'Delete area': 'Delete area open' } }),
);
const isChangeConfirmationVisible = computed(() =>
    snapshot.value.matches({ 'Edit popup open': { 'Review area': 'Review area open' } }),
);
const isReviewSectionVisible = computed(() => isDeleteConfirmationVisible.value || isChangeConfirmationVisible.value);
const isEditEntireAllocationTabActive = computed(() =>
    snapshot.value.matches({ 'Edit popup open': { 'Tab navigation': 'Edit entire allocation' } }),
);
const isEditPhasesTabActive = computed(() =>
    snapshot.value.matches({ 'Edit popup open': { 'Tab navigation': 'Edit phases' } }),
);
const isMoveDateTabActive = computed(() =>
    snapshot.value.matches({ 'Edit popup open': { 'Tab navigation': 'Move date' } }),
);

const hasEditEntireAllocationTabChanges = computed(
    () =>
        snapshot.value.context.isAllocationOptional.temporary !==
            snapshot.value.context.isAllocationOptional.confirmed ||
        snapshot.value.context.referenceAllocation.temporaryId !==
            snapshot.value.context.referenceAllocation.confirmedId,
);
const hasEditPhasesTabChanges = computed(() =>
    snapshot.value.context.phaseGroups.some(
        (phaseGroup) =>
            phaseGroup.temporaryCellSpanBefore !== 0 ||
            phaseGroup.temporaryCellSpanAfter !== 0 ||
            phaseGroup.temporarySpecialization !== phaseGroup.confirmedSpecialization,
    ),
);
const hasMoveDateTabChanges = computed(() => false); // TODO Set correctly once this tab is implemented

const editPopupRef = ref(null);
const { width: editPopupWidth } = useElementSize(editPopupRef);

const minimalRequiredWidth = ref(0);
watchEffect(() => {
    if (minimalRequiredWidth.value === 0 && editPopupWidth.value !== 0) {
        minimalRequiredWidth.value = editPopupWidth.value;
    }
});

const invisibleCellSpanBefore = computed(() => {
    return Math.max(timelineRange.startDateTime.value.diff(props.startDateTime, 'days').days, 0);
});

const invisibleCellSpanAfter = computed(() => {
    return Math.max(props.endDateTime.diff(timelineRange.endDateTime.value, 'days').days, 0);
});

/**
 * The allocation inside of the edit popup should always be centered. Therefore, we have to compensate for temporary cells spans that are added left or right of the existing ones.
 */
const temporaryCellSpansAddedAfter = computed(() => {
    return snapshot.value.context.phaseGroups.reduce((sum, phaseGroup) => {
        if (phaseGroup.temporaryCellSpanAfter > 0) {
            return sum + phaseGroup.temporaryCellSpanAfter;
        }

        return sum;
    }, 0);
});

const temporaryCellSpansAddedBefore = computed(() => {
    return snapshot.value.context.phaseGroups.reduce((sum, phaseGroup) => {
        if (phaseGroup.temporaryCellSpanBefore > 0) {
            return sum + phaseGroup.temporaryCellSpanBefore;
        }

        return sum;
    }, 0);
});

const leftRightCompensationInRem = computed(() => {
    const leftDifferenceTemporaryCellSpans = Math.max(
        temporaryCellSpansAddedAfter.value - temporaryCellSpansAddedBefore.value,
        0,
    );
    const rightDifferenceTemporaryCellSpans = Math.max(
        temporaryCellSpansAddedBefore.value - temporaryCellSpansAddedAfter.value,
        0,
    );

    const columnWidthAndBorder = columnWidthInRem + 0.0625;

    return {
        left: columnWidthAndBorder * leftDifferenceTemporaryCellSpans,
        right: columnWidthAndBorder * rightDifferenceTemporaryCellSpans,
        leftOffset: (-(invisibleCellSpanBefore.value - invisibleCellSpanAfter.value) / 2) * columnWidthAndBorder,
    };
});

const widthStyle = computed(() => {
    return {
        minWidth: `${minimalRequiredWidth.value}px`,
    };
});

// Required to calculate the width of the allocation bar when the edit popup is open as the phase groups are placed on a separate allocation bar inside the edit popup and thus the reference width would be 0 otherwise and the positioning of the edit popup would fail
const allocationWrapperWidthStyle = computed(() => {
    const cellCount = snapshot.value.context.phaseGroups.reduce((count, phaseGroup) => {
        return count + phaseGroup.confirmedVisibleCellSpan;
    }, 0);

    return {
        minWidth: `calc(${columnWidthInRem * cellCount}rem + ${cellCount - 1}px)`,
    };
});

const allocationWrapperRef = ref<InstanceType<typeof AllocationWrapper>>();
const allocationWrapperElement = computed(() => allocationWrapperRef.value?.wrapperRef);
const { floatingStyles } = useFloating(allocationWrapperElement, editPopupRef, {
    middleware: [
        offset(() => ({
            crossAxis: leftRightCompensationInRem.value.leftOffset * 16,
        })),
    ],
    open: isEditPopupOpen,
    placement: 'top',
    whileElementsMounted: autoUpdate,
});

// This is used to force close the Tooltip after clicking the button
const triggerHideTooltipKeyCounter = ref(0);
provide(triggerHideTooltipKey, triggerHideTooltipKeyCounter);

function triggerHideTooltip() {
    triggerHideTooltipKeyCounter.value = triggerHideTooltipKeyCounter.value + 1;
}

function getAllowedSpecializationTypesForPhaseType(
    phaseType: PhaseTypeDatabase,
    isInside: boolean,
): (SpecializationType | null)[] {
    if (phaseType === AllocationUsageType.ShowDays) {
        if (isInside) {
            return [
                null,
                'Parking',
                'Catering',
                'Storage',
                'Mobile-Entrance',
                'Congress',
                'Logistics',
                'Cloakroom',
                'Service-Center',
                'Routing',
                'Party',
            ];
        } else {
            return [null, 'Parking', 'Service-Assembly-Point', 'Open-Air-Ground', 'Evacuation-Corridor'];
        }
    }

    if (phaseType === ProjectAllocationUsageType.Project) {
        return [null, 'Building-Activity', 'Maintenance', 'Forbidden-Zone'];
    }

    return [];
}

function getPhaseName(phaseType: PhaseTypeDatabase): string {
    const usage = props.allocationUsages.find((allocationUsage) => allocationUsage.type === phaseType);

    if (!usage) {
        throw new Error(`Missing allocation usage for phase type: ${phaseType}`);
    }

    return usage.name;
}

const labelPaddingInRem = 4 / 16;

const clipPathId = computed(() => `textClip-${props.id}`);

const visibleCellsStartDateTime = computed(() =>
    props.startDateTime > timelineRange.startDateTime.value ? props.startDateTime : timelineRange.startDateTime.value,
);

const visibleCellsEndDateTime = computed(() =>
    props.endDateTime < timelineRange.endDateTime.value ? props.endDateTime : timelineRange.endDateTime.value,
);

const textClipWidthInPx = computed(() => {
    const visibleDays = visibleCellsEndDateTime.value.diff(visibleCellsStartDateTime.value, 'days').days;
    if (visibleDays < 0) {
        // for allocations outside of the timerange, there is no need for textclipwidth
        // there might be a better fix for this scenario, but for now it fixes the occuring error
        return 0;
    }
    const columnWidthInPx = columnWidthInRem * 16;
    const totalWidthInPx = columnWidthInPx * visibleDays + (visibleDays - 1);
    const labelPaddingInPx = labelPaddingInRem * 16;

    const referenceAllocationIcon = isReferenceAllocation.value ? 12 + 4 : 0; // 16px size + 6px margin
    return totalWidthInPx - labelPaddingInPx - referenceAllocationIcon;
});

const clickBehavior = computed(() => {
    const { clickAction } = props;

    // Selection mode is on for exactly as long as an edit popup is open. It also outlives the popup while
    // the origin row is collapsed, where the checkboxes stay up and a click here would hijack the selection.
    if (locationSelectionStore.isActive && !isEditPopupOpen.value) {
        return { isClickable: false, tooltipText: $t('other-allocation-is-being-edited') };
    }

    if (clickAction.type === 'Jump-To-Allocation' && !snapshot.value.context.isReferenceAllocationRegistered) {
        return { isClickable: false, tooltipText: $t('jump-to-referenced-allocation-not-visible') };
    }

    switch (clickAction.type) {
        case 'Edit':
            return { isClickable: true, tooltipText: $t('click-to-edit-allocation') };

        case 'Jump-To-Allocation':
            return { isClickable: true, tooltipText: $t('jump-to-referenced-allocation') };

        case 'Open-Url':
            return { isClickable: true, tooltipText: clickAction.tooltipText };

        case 'No-Action':
            return { isClickable: false, tooltipText: clickAction.tooltipText };

        default:
            throw new Error(`Unhandled click action: ${clickAction satisfies never}`);
    }
});

function mapVariant(variant: (typeof props)['variant'], isOptional: boolean) {
    switch (variant) {
        case 'Solid':
            return isOptional ? 'Strong-Optional' : 'Strong-Mandatory';

        case 'Outer-Semi-Transparent':
            return isOptional ? 'Inner-Strong-Optional' : 'Inner-Strong-Mandatory';

        case 'Semi-Transparent':
            return isOptional ? 'Light-Optional' : 'Light-Mandatory';

        case 'Faint':
            return isOptional ? 'Faint-Optional' : 'Faint-Mandatory';

        default:
            throw new Error(`Unknown variant: ${variant}`);
    }
}

function calculateVariant(
    isAllocationOptional: boolean,
    confirmedVisibleCellSpan: number,
    temporaryCellSpanBefore: number,
    temporaryCellSpanAfter: number,
    allocationPartInGroupIndex: number,
) {
    if (temporaryCellSpanBefore < 0) {
        if (allocationPartInGroupIndex <= Math.abs(temporaryCellSpanBefore)) {
            return isAllocationOptional ? 'Light-Red-Border-Optional' : 'Light-Red-Border-Mandatory';
        }
    }

    if (temporaryCellSpanAfter < 0) {
        const positionFromEnd = confirmedVisibleCellSpan - allocationPartInGroupIndex + 1;
        if (positionFromEnd <= Math.abs(temporaryCellSpanAfter)) {
            return isAllocationOptional ? 'Light-Red-Border-Optional' : 'Light-Red-Border-Mandatory';
        }
    }

    return isAllocationOptional ? 'Strong-Optional' : 'Strong-Mandatory';
}

const isAllocationVariantHovered = ref(false);
const isAllocationWrapperHovered = ref(false);

const allocationWrapperStatus = computed(() => {
    if (snapshot.value.matches('Activated')) {
        return 'Focused';
    }
    if (isEditPopupOpen.value) {
        return 'Open';
    }
    if (isAllocationWrapperHovered.value && clickBehavior.value.isClickable) {
        return 'Hovered';
    }
    return 'Default';
});

function hasTemporaryPhasesBefore(
    temporaryCellSpanBefore: number,
    phaseGroups: PhaseGroupType[],
    phaseGroupIndex: number,
): boolean {
    if (temporaryCellSpanBefore > 0) {
        return true;
    }

    if (phaseGroupIndex > 0 && phaseGroups.length > 0) {
        return (
            phaseGroups[phaseGroupIndex - 1].confirmedCellSpan > 0 ||
            phaseGroups[phaseGroupIndex - 1].temporaryCellSpanBefore > 0 ||
            phaseGroups[phaseGroupIndex - 1].temporaryCellSpanAfter > 0
        );
    }

    return false;
}

function hasTemporaryPhasesAfter(
    temporaryCellSpanAfter: number,
    phaseGroups: PhaseGroupType[],
    phaseGroupIndex: number,
): boolean {
    if (temporaryCellSpanAfter > 0) {
        return true;
    }

    if (phaseGroupIndex < phaseGroups.length - 1) {
        return (
            phaseGroups[phaseGroupIndex + 1].confirmedCellSpan > 0 ||
            phaseGroups[phaseGroupIndex + 1].temporaryCellSpanBefore > 0 ||
            phaseGroups[phaseGroupIndex + 1].temporaryCellSpanAfter > 0
        );
    }

    return false;
}

function isPhaseEnd(allocationPartIndex: number, phaseGroup: PhaseGroupType) {
    return (
        allocationPartIndex === phaseGroup.confirmedVisibleCellSpan &&
        phaseGroup.confirmedCellSpan === phaseGroup.confirmedVisibleCellSpan &&
        phaseGroup.temporaryCellSpanAfter === 0
    );
}

function onMouseDown() {
    if (clickBehavior.value.isClickable) {
        send({ type: 'Activate popup' });
    }
}

function onJumpToReferenceAllocation() {
    triggerHideTooltip();
    send({ type: 'Close popup' });

    // Unconfirmed changes make the machine refuse the close; scrolling away regardless would leave the popup
    // open over a different part of the timeline
    if (isEditPopupOpen.value) {
        return;
    }

    if (
        snapshot.value.context.referenceAllocation.confirmedId &&
        snapshot.value.context.isReferenceAllocationRegistered
    ) {
        store.jumpToAllocation(snapshot.value.context.referenceAllocation.confirmedId);
    }
}

function onTrigger() {
    triggerHideTooltip();

    // The jump and URL branches act directly rather than through the machine, so its guard misses them.
    if (!clickBehavior.value.isClickable) {
        return;
    }

    switch (props.clickAction.type) {
        case 'Edit':
            send({ type: 'Open popup' });
            break;

        case 'Jump-To-Allocation': {
            send({ type: 'Inactivate popup' });

            const refAllocId = store.getReferenceAllocationId(props.allocationVariant.id);
            if (!refAllocId) {
                throw new Error('Missing reference allocation ID for Jump-To-Allocation action');
            }

            store.jumpToAllocation(refAllocId);
            break;
        }

        case 'Open-Url': {
            send({ type: 'Inactivate popup' });
            const url = router.resolve(props.clickAction.target).href;
            window.open(url, '_blank');
            break;
        }

        case 'No-Action':
            break;
    }
}
</script>

<style scoped>
.wrapper-border-gray-700::before {
    content: '';
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border: 1px solid var(--color-gray-700);
}

.fading-out-highlight {
    animation: ease-in-out fading-out-border 5s;
}

@keyframes fading-out-border {
    0% {
        z-index: 100;
        box-shadow: 0 0 0 0.25rem var(--color-sky-700);
    }

    100% {
        z-index: auto;
        box-shadow: 0;
    }
}
</style>
